interface ScrollIntoViewOptions {
  enabled?: boolean;
  offset: number;
  onFocus?: () => void;
}

const useScrollIntoView = <T extends HTMLElement = HTMLElement>({
  enabled = true,
  offset,
  onFocus
}: ScrollIntoViewOptions) => {
  const handleFocus = (event: React.FocusEvent<T>) => {
    if (enabled) {
      // the timeout is to ensure the focus is fully applied
      setTimeout(() => {
        const rect = event.target.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const elementHeight = rect.height;

        const targetY = window.scrollY + rect.top - (viewportHeight - elementHeight) / 2 + offset;

        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      }, 300);
    }
    onFocus?.();
  };

  return handleFocus;
};

export default useScrollIntoView;
